export default __webpack_public_path__ + "static/media/img_default.0bcbabb7.svg";